import { extractArrayFromQuery } from '../../../utils/query';

export default {
  param: extractArrayFromQuery,
  query: function (values) {
    if (values.length > 0) {
      return {
        $or: values.map(function(value) {
          return {
            completed: {
              1: true,
              2: false
            }[value]
          }
        })
      }
    }
  }
}
